/*************************************************/
/* TEXT COLLAPSE                                 */
/*************************************************/

export function textCollapse() {
    document.addEventListener("DOMContentLoaded", function () {
        const toggleMoreButtons = document.querySelectorAll(".product-page__toggle");

        toggleMoreButtons.forEach(button => {
            button.addEventListener("click", function () {
                const container = button.closest(".product-page__text-container");
                const hiddenContainer = container.querySelector(".product-page__text--hidden-container");
                const hiddenText = hiddenContainer.querySelector(".product-page__text--hidden");

                // Expand the hidden text
                hiddenText.style.maxHeight = hiddenText.scrollHeight + "px";
                hiddenContainer.classList.add("expanded");

                // Hide the "Read More" button and show the "Read Less" button
                button.classList.remove("product-page__toggle--active");
            });
        });
    });
}